import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Link } from "react-router-dom";
import { TostMsg } from "../../../../App";
import {
  useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import {
  uploadImageAlbum,
  DeleteAlbumImage,
  getAlbumMediaImages,
  likeAlbumImage,
  albumImageComment,
} from "../galleryService";
import { uploadDoc } from "../../../../Services/Global-Services/GlobalServices";
import { Dialog } from "primereact/dialog";
import moment from "moment";
import { LazyImage } from "../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import { PostDate } from "../../Dashboard/CommonComponents/PostDate";
import Commnent from "../../../../Services/Comment/comment";
import { getEmployeeList } from "../../EmployeeList/Service/employeeService";
import { lazy } from "react";
import ImageCropperModalMulti from "../../../../Services/Comment/ImageCropperModalMulti";
import UploadFile_KEYS from "../../../../Services/Global-Services/UploadFile_Keys";
const ComponentLoader = React.memo(
  lazy(() => import("../../../../Shared/Sidebar/ComponentLoader")),
);

function SingleGallery() {
  const toster = useContext(TostMsg);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [loader, setLoader] = useState(false);
  const { AlbumId } = useParams();
  const [albumData, setAlbumData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState([]);
  const [uploadImage, setUploadImage] = useState("Upload Image/Video");
  const [imageDetailShow, setimageDetailShow] = useState(false);
  const [imageDetail, setImageDetail] = useState([]);
  const [albumDetail, setAlbumDetail] = useState([]);
  const [albumDeleteLst, setAlbumImageLst] = useState(0);
  const [videoPath, setVideoPath] = useState([]);
  const [galleryHeader, setGalleryHeader] = useState("");
  const [imageComment, setImageComment] = useState("");
  const [EditCommentId, setEditCommentId] = useState(null);
  const [hasMore, setHasMore] = useState(false);
  const [employee, setEmployee] = useState([]);
  const [mediaActiveIndex, setMediaActiveIndex] = useState(0);
  const [imageSrc, setImageSrc] = useState(null); // for single image
  const [multiImageSrcs, setMultiImageSrcs] = useState([]); // for multiple
  const [showCropper, setShowCropper] = useState(false);
  const [acceptRatio, setAcceptRatio] = useState(1 / 1);
  const [noData, setNoData] = useState([]);
  const videoFilesRef = useRef([]);
  const [showGallaryDataNotFound, setShowGallaryDataNotFound] = useState(false);
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [galleryCreate, setGalleryCreate] = useState(false);
  let mediaId = 0;
  const defaultImage = "/images/placeholder_profile.png";
  const GalleryDefaultImage = "/images/no-data-found/feed_dummy.png";
  let changedImageId = 0;
  let currentIndex;
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [mouseDrag, setMouseDrag] = useState(false);

  const location = useLocation();

  useEffect(() => {
    permissionAccouncementList();
    GetMasterSystemAlertList("single_album_header", 0);
    GetMasterSystemAlertList("Picture_Unavailable", 1);
    getAllDetailsMeadia();
    fetchEmployeeData();
  }, []);

  const permissionAccouncementList = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Album.Create") {
        setGalleryCreate(true);
      }
    });
  };

  async function fetchEmployeeData() {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 5000000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    try {
      let employeesList = await getEmployeeList(params);
      setEmployee(employeesList.Data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }
  const getAllDetailsMeadia = async () => {
    setLoading(true);
    const param = {
      AlbumId: 0,
      LoggedInUserId: Number(userDetails?.EmpKeyValues[0]?.EmpId),
      OrgId: Number(userDetails?.EmpKeyValues[0]?.OrgId),
      AlbumMediaId: 0,
      PageNumber: 1,
      PageSize: 1000,
      RecentPicture: 0,
      AlbumGUID: AlbumId,
    };
    try {
      const response = await getAlbumMediaImages(param);
      setAlbumData(response.Data?.orgAlbums);
      setAlbumDetail(response.Data?.AlbumDetails);
      if (response?.Data?.orgAlbums?.length === 0) {
        setShowGallaryDataNotFound(true);
      } else {
        setShowGallaryDataNotFound(false);
      }
      let updatedImageDetail;
      const imageId = mediaId || imageDetail[0]?.Id;
      if (imageId) {
        updatedImageDetail = response?.Data?.orgAlbums?.find(
          (el) => el?.Id == imageId,
        );
        setImageDetail(updatedImageDetail);
      }
      if (response?.Data?.length > 0) {
        setHasMore(true);
      }
      setLoading(false);
      setHasMore(false);
    } catch (error) {
      setHasMore(false);
      setLoading(false);
    }
  };

  useEffect(() => {}, [mediaId, albumData]);

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const handleGalleryDefaultImage = useCallback((event) => {
    event.target.src = GalleryDefaultImage;
  }, []);

  const fileInputRef = useRef(null);
  function openFileInput() {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  }

  useEffect(() => {
    if (file?.length > 0) {
      uploadMediaFile();
    }
  }, [file]);

  async function uploadMediaFile() {
    setLoading(true);
    if (file && file.length > 0) {
      const formData = new FormData();
      for (let i = 0; i < file.length; i++) {
        formData.append("files", file[i]);
      }
      let params = {
        UploadType: UploadFile_KEYS?.Album,
        RefId: albumData?.Id ?? 0,
      };
      try {
        const response = await uploadDoc(params, formData);
        const data = await response;
        setLoading(false);
        const ImageURL = data?.Data;
        if (ImageURL && ImageURL.length > 0) {
          const processedMedia = [];
          for (let i = 0; i < ImageURL.length; i++) {
            const media = ImageURL[i];
            const currentFile = file[i];
            if (media.slice(-3) === "mp4") {
              const duration = await getVideoDuration(media);
              processedMedia.push({
                MediaPath: media,
                MediaSize: currentFile.size,
                MediaDuration: duration,
                MediaType: currentFile.type,
              });
            } else {
              processedMedia.push({
                MediaPath: media,
                MediaSize: currentFile.size,
                MediaDuration: 0,
                MediaType: currentFile.type,
              });
            }
          }
          setVideoPath((prev) => [...prev, ...processedMedia]);
        }
      } catch (error) {
        setLoading(false);
        toster.current.error(ERROR_LIST.UploadFileError);
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
      toster.current.warn("No file selected.");
    }
  }

  const handleFileChange = async (event, type) => {
    const files = Array.from(event.target.files);
    const MAX_FILE_SIZE = 20 * 1024 * 1024;
    const oversizedFiles = files.filter((file) => file.size > MAX_FILE_SIZE);

    if (!files.length) return;
    if (oversizedFiles.length <= 0) {
      // setFileSizeError('');
      const imageFiles = files.filter((file) => file.type.startsWith("image/"));
      const videoFiles = files.filter((file) => file.type.startsWith("video/"));
      videoFilesRef.current = videoFiles;
      if (imageFiles.length > 0) {
        try {
          const imageDataURLs = await Promise.all(
            imageFiles.map((file) => {
              return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
              });
            }),
          );

          if (imageDataURLs.length > 0) {
            setImageSrc(null);
            setMultiImageSrcs(imageDataURLs);
            setAcceptRatio(1 / 1);
            setShowCropper(true);
          }
        } catch (err) {
          console.error("Failed to read image files", err);
        }
      } else if (videoFiles.length > 0) {
        setFile(videoFiles);
        videoFilesRef.current = [];
      }
      fileInputRef.current.value = "";
    } else {
      toster.current.error("File too large. Maximum size: 20 MB.");
      // setFileSizeError('File too large. Maximum size: 20 MB.')
    }
  };

  const handleCropComplete = (croppedData) => {
    const blobs = Array.isArray(croppedData) ? croppedData : [croppedData];
    const croppedFiles = blobs.map(
      (blob, index) =>
        new File([blob], `cropped-${index + 1}.jpg`, { type: "image/jpeg" }),
    );
    const finalFiles = [...croppedFiles, ...videoFilesRef.current];
    setFile(finalFiles);
    videoFilesRef.current = [];
  };

  // Helper function to get video duration
  function getVideoDuration(mediaPath) {
    return new Promise((resolve) => {
      const videoElement = document.createElement("video");
      videoElement.src = mediaPath;
      videoElement?.addEventListener("loadedmetadata", () => {
        resolve(videoElement.duration);
      });
    });
  }

  useEffect(() => {
    if (videoPath?.length > 0) {
      uploadedImagesData();
    }
  }, [videoPath]);

  const uploadedImagesData = useCallback(async () => {
    if (videoPath.length > 0) {
      setLoading(true);
      const body = {
        AlbumId: albumDetail?.Id,
        GUID: AlbumId,
        AlbumMedias: videoPath,
      };
      try {
        await uploadImageAlbum(body);
        getAllDetailsMeadia();
        setVideoPath([]);
        setUploadImage("Upload Image/Video");
        toster.current.success("Album updated successfully");
        setLoading(false);
      } catch (err) {
        toster.current.error(
          "An unexpected error occurred in uploading media.",
        );
        setLoading(false);
      }
    } else {
      setLoading(false);
      document.getElementById("fileInput").click();
    }
  }, [videoPath]);

  const handleCreatedAlbumDelete = (lst) => {
    setAlbumImageLst(lst);
  };

  async function deleteAlbumImage() {
    if (albumDeleteLst) {
      let body = {
        ImageId: albumDeleteLst?.Id,
        AlbumId: albumDeleteLst?.AlbumId,
      };
      setLoading(true);
      try {
        let experiencesLists = await DeleteAlbumImage(body);
        if (experiencesLists) {
          getAllDetailsMeadia();
          toster.current.success("Image deleted successfully");
          setLoading(false);
          document.getElementById("delete-ed").click();
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
        setLoading(false);
      }
    }
  }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        setGalleryHeader(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setNoData(msg?.Desc);
      }
    });
  }, []);

  // likeAlbumImage
  const AlbumImageLike = useCallback(async (imageDetail, type) => {
    mediaId = imageDetail?.Id;
    let MyLikeId = 0;
    let IsActive = true;
    if (imageDetail?.IsLikedByMe == 1) {
      MyLikeId = imageDetail?.MyLikeId;
    } else {
      MyLikeId = 0;
    }
    if (imageDetail?.Reaction == type) {
      IsActive = false;
    } else {
      IsActive = true;
    }
    let body = {
      Id: MyLikeId,
      EmpId: userDetails?.EmpId,
      AlbumMediaId: imageDetail?.Id,
      Reaction: type,
      IsActive: IsActive,
    };
    try {
      await likeAlbumImage(body);
      setMouseDrag(false);
      getAllDetailsMeadia();
      return false;
    } catch (error) {
      setLoading(false);
    }
  }, []);

  const DeleteComment = async (el) => {
    mediaId = imageDetail?.Id;
    let body = {
      Id: el.Id,
      EmpId: userDetails?.EmpId,
      AlbumMediaId: el.AlbumMediaId,
      Reaction: imageComment,
      IsActive: false,
    };
    setLoader(true);
    try {
      await albumImageComment(body);
      getAllDetailsMeadia();
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };

  const EmojiReaction = (reaction) => {
    if (reaction != undefined) {
      let newReaction = reaction?.map((el) => el?.Reaction);
      var replaceSameEmoji = newReaction?.toString();
      const replacedEmoji = Array.from(
        new Set(replaceSameEmoji?.split(",")),
      )?.join(",");
      return (
        <div className="emojis-group">
          {replacedEmoji.includes("Love") ? (
            <img
              src="/images/main-body/post/emojis/1.gif"
              width="100%"
              style={{
                opacity: "1",
                borderRadius: "100%",
                marginLeft: "0px",
              }}
            />
          ) : (
            ""
          )}
          {replacedEmoji.includes("Like") ? (
            <img
              src="/images/main-body/post/emojis/0.gif"
              width="100%"
              style={{
                opacity: "1",
                borderRadius: "100%",
                marginLeft: "0px",
              }}
            />
          ) : (
            ""
          )}
          {replacedEmoji.includes("Laugh") ? (
            <img
              src="/images/main-body/post/emojis/2.gif"
              width="100%"
              style={{
                opacity: "1",
                borderRadius: "100%",
                marginLeft: "0px",
              }}
            />
          ) : (
            ""
          )}
          {replacedEmoji.includes("Surprised") ? (
            <img
              src="/images/main-body/post/emojis/3.gif"
              width="100%"
              style={{
                opacity: "1",
                borderRadius: "100%",
                marginLeft: "0px",
              }}
            />
          ) : (
            ""
          )}
          {replacedEmoji.includes("Sad") ? (
            <img
              src="/images/main-body/post/emojis/5.gif"
              width="100%"
              style={{
                opacity: "1",
                borderRadius: "100%",
                marginLeft: "0px",
              }}
            />
          ) : (
            ""
          )}
        </div>
      );
    } else {
      <a className="like-button likes">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-heart"
          viewBox="0 0 16 16"
        >
          <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143q.09.083.176.171a3 3 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15" />
        </svg>

        <span className="like-overlay"></span>
      </a>;
      // <div> <i className="fa fa-heart-o heart-fa" />
      //   💗
      // </div>
    }
  };

  const UserEmojiReaction = (reaction) => {
    var replaceSameEmoji = reaction?.toString();
    const replacedEmoji = Array.from(
      new Set(replaceSameEmoji?.split(",")),
    )?.join(",");
    return (
      <div
        className="emojis-group emojis-byuser"
        onMouseEnter={() => setMouseDrag(true)}
        onMouseLeave={() => setMouseDrag(false)}
      >
        {replacedEmoji?.includes("Love") ? (
          <LazyImage src="/images/main-body/post/emojis/1.gif" alt="" />
        ) : replacedEmoji?.includes("Like") ? (
          <LazyImage src="/images/main-body/post/emojis/0.gif" alt="" />
        ) : replacedEmoji?.includes("Laugh") ? (
          <LazyImage src="/images/main-body/post/emojis/2.gif" alt="" />
        ) : replacedEmoji?.includes("Surprised") ? (
          <LazyImage src="/images/main-body/post/emojis/3.gif" alt="" />
        ) : replacedEmoji?.includes("Sad") ? (
          <LazyImage src="/images/main-body/post/emojis/5.gif" alt="" />
        ) : (
          <a className="like-button">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-heart"
              viewBox="0 0 16 16"
            >
              <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143q.09.083.176.171a3 3 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15" />
            </svg>
            <span className="like-overlay"></span>
          </a>
        )}
      </div>
    );
  };

  const FeedMediaTemplate = useCallback(
    (media, index) => {
      const isVideo =
        media?.MediaPath?.endsWith(".mp4") ||
        media?.MediaPath?.toLowerCase()?.endsWith(".mov");
      const mediaSrc = media?.MediaPath || defaultImage;
      const handlePlayPause = (e) => {
        const video = e.target.closest(".video-wrapper").querySelector("video");
        const button = e.target;
        if (video.paused) {
          video.play();
          button.textContent = "⏸";
        } else {
          video.pause();
          button.textContent = "▶";
        }
      };

      return isVideo ? (
        <div className="video-wrapper">
          <video
            src={mediaSrc}
            playsInline
            muted
            key={index}
            width="100%"
            height="100%"
            id="video1"
            onClick={() => {
              setimageDetailShow(true);
              ImageSliderList(media);
              setMediaActiveIndex(index);
            }}
          />
          <button
            className="custom-play-button"
            onClick={handlePlayPause}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                handlePlayPause(e);
              }
            }}
            aria-label="Play/Pause Video"
          >
            ▶
          </button>
        </div>
      ) : (
        <img
          src={mediaSrc || GalleryDefaultImage}
          onError={handleGalleryDefaultImage}
          key={index}
          onClick={() => {
            setimageDetailShow(true);
            ImageSliderList(media);
            setMediaActiveIndex(index);
          }}
          alt="Description of the image"
        />
      );
    },
    [mediaActiveIndex],
  );

  const ImageSliderList = useCallback(
    (lst) => {
      setImageDetail(lst);
    },
    [imageDetail],
  );

  const FeedMediaCarouselTemplate = useCallback(
    (media) => {
      const isVideo =
        media?.MediaPath?.endsWith(".mp4") ||
        media?.MediaPath?.toLowerCase()?.endsWith(".mov");
      const mediaSrc = media?.MediaPath || defaultImage;

      const handlePlayPause = (videoRef, playButton) => {
        if (videoRef.paused) {
          videoRef.play();
          playButton.textContent = "⏸";
        } else {
          videoRef.pause();
          playButton.textContent = "▶";
        }
      };

      const updateProgress = (videoRef, progressBar) => {
        const percentage = (videoRef.currentTime / videoRef.duration) * 100;
        progressBar.style.width = `${percentage}%`;
      };

      const handleMuteUnmute = (videoRef, muteButton) => {
        if (videoRef.muted) {
          videoRef.muted = false;
          muteButton.textContent = "🔊";
        } else {
          videoRef.muted = true;
          muteButton.textContent = "🔇";
        }
      };

      const handleDownload = (mediaSrc) => {
        const link = document.createElement("a");
        link.href = mediaSrc;
        link.download = "video.mp4";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };

      const handlePlaybackSpeed = (videoRef, speed) => {
        videoRef.playbackRate = speed;
      };

      const handlePictureInPicture = (videoRef) => {
        if (document.pictureInPictureElement) {
          document.exitPictureInPicture();
        } else {
          videoRef.requestPictureInPicture().catch((error) => {
            console.error("Error entering Picture-in-Picture mode:", error);
          });
        }
      };

      return isVideo ? (
        <div
          className="custom-video-wrapper"
          style={{
            position: "relative",
            width: "100%",
            height: "100%",
          }}
        >
          <video
            src={mediaSrc}
            key={imageDetail?.Id == media?.Id}
            playsInline
            muted
            width="100%"
            height="100%"
            onTimeUpdate={(e) =>
              updateProgress(
                e.target,
                e.target
                  .closest(".custom-video-wrapper")
                  .querySelector(".progress-bar"),
              )
            }
          />
          <div
            className="custom-controls"
            style={{
              position: "absolute",
              bottom: 0,
              width: "100%",
              background: "rgba(0, 0, 0, 0.8)",
              display: "flex",
              alignItems: "center",
              padding: "10px",
              zIndex: 10,
            }}
          >
            <button
              className="play-button"
              onClick={(e) =>
                handlePlayPause(
                  e.target
                    .closest(".custom-video-wrapper")
                    .querySelector("video"),
                  e.target,
                )
              }
              style={{
                background: "none",
                border: "none",
                color: "white",
                fontSize: "16px",
                cursor: "pointer",
              }}
            >
              ▶
            </button>
            <div
              className="progress-container"
              style={{
                flex: 1,
                margin: "0 10px",
                background: "rgba(255, 255, 255, 0.2)",
                height: "5px",
                position: "relative",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              <div
                className="progress-bar"
                style={{
                  width: "0%",
                  height: "100%",
                  background: "#00B3E3",
                  borderRadius: "5px",
                }}
              ></div>
            </div>

            <button
              className="mute-button"
              onClick={(e) =>
                handleMuteUnmute(
                  e.target
                    .closest(".custom-video-wrapper")
                    .querySelector("video"),
                  e.target,
                )
              }
              style={{
                background: "none",
                border: "none",
                color: "white",
                fontSize: "16px",
                cursor: "pointer",
              }}
            >
              🔊
            </button>
            <input
              type="range"
              className="volume-slider"
              min="0"
              max="1"
              step="0.1"
              defaultValue="1"
              style={{
                width: "100px",
                marginLeft: "10px",
              }}
            />
            <select
              onChange={(e) =>
                handlePlaybackSpeed(
                  e.target
                    .closest(".custom-video-wrapper")
                    .querySelector("video"),
                  e.target.value,
                )
              }
              style={{
                marginLeft: "10px",
                background: "rgba(255, 255, 255, 0.1)",
                color: "white",
                border: "none",
                padding: "5px",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              <option value="0.5">0.5x</option>
              <option value="1" selected>
                1x
              </option>
              <option value="1.5">1.5x</option>
              <option value="2">2x</option>
            </select>
            <button
              className="pip-button"
              onClick={(e) =>
                handlePictureInPicture(
                  e.target
                    .closest(".custom-video-wrapper")
                    .querySelector("video"),
                )
              }
              style={{
                background: "none",
                border: "none",
                color: "white",
                fontSize: "16px",
                cursor: "pointer",
                marginLeft: "10px",
              }}
            >
              ⛶
            </button>
            <button
              className="download-button"
              onClick={() => handleDownload(mediaSrc)}
              style={{
                background: "none",
                border: "none",
                color: "white",
                fontSize: "16px",
                cursor: "pointer",
                marginLeft: "10px",
              }}
            >
              ⬇
            </button>
          </div>
        </div>
      ) : (
        <img
          src={mediaSrc || GalleryDefaultImage}
          onClick={() => {
            setimageDetailShow(true);
            ImageSliderList(media);
          }}
          onError={handleGalleryDefaultImage}
          alt="Description of the image"
        />
      );
    },
    [imageDetail],
  );

  const EditComment = useCallback(
    (event) => {
      setEditCommentId(1);
      setImageComment(event);
    },
    [imageComment, EditCommentId],
  );

  const AlbumImageComment = async (CommentData, Null, CommentText, type) => {
    mediaId = imageDetail?.Id;
    let CommentId = 0;
    if (CommentData == "") {
      CommentId = 0;
    } else {
      CommentId = CommentData?.Id;
    }
    if (imageDetail) {
      let body = {
        Id: CommentId,
        EmpId: userDetails?.EmpId,
        AlbumMediaId: imageDetail?.Id,
        Reaction: CommentText,
        IsActive: true,
      };
      setLoader(true);
      try {
        await albumImageComment(body);
        getAllDetailsMeadia();
        setImageComment("");
        setEditCommentId(null);
        setLoader(false);
      } catch (error) {
        setLoader(false);
      }
    } else {
      setLoader(false);
      toster.current.error("Please add comment");
    }
  };

  const renderFeedText = (text) => {
    const mentionRegex = /@\w+/g;
    const hashtagRegex = /#\w+/g;
    let newText = text?.replace(mentionRegex, (mention) => {
      return `<a>${mention.substring(1)}</a>`;
    });
    newText = newText?.replace(hashtagRegex, (hashtag) => {
      return `<a style={{ color: "#c4c6c7"}}>${hashtag}</a>`;
    });
    return { __html: newText };
  };
  return (
    <div className=" gallery-popupdiv">
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="top-gallery-title">
            <div className="me-auto singlealbum">
              {albumDetail ? (
                <h2 className="main-titleh2 mb-0 break-text">
                  {" "}
                  {albumDetail?.Name}
                </h2>
              ) : (
                <h2 className="font-w600 mb-0">Single album</h2>
              )}
              <p title={galleryHeader} className="lowertext break-text">
                {albumDetail?.Description}
              </p>
              <div className="media-meta">
                <span>Created by </span>
                <img
                  src={albumDetail?.EmployeeProfileImage || defaultImage}
                  onError={handleImageError}
                />
                <a className="meta-item is-hoverable">
                  {" "}
                  {albumDetail ? <span> {albumDetail?.EmployeeName}</span> : ""}
                </a>
                <span className="separator">|</span>
                <span className="meta-item d-flex align-items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="11"
                    fill="currentColor"
                    className="bi bi-calendar me-1"
                    viewBox="0 0 16 16"
                  >
                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                  </svg>
                  Date{" "}
                  {moment(albumDetail?.ModifiedDate).format("MMM DD YYYY")}{" "}
                </span>
              </div>
            </div>
            {showCropper && (
              <ImageCropperModalMulti
                image={imageSrc}
                images={multiImageSrcs}
                acceptRatio={acceptRatio}
                onComplete={handleCropComplete}
                onClose={() => setShowCropper(false)}
              />
            )}
            <div className="rightside-tabs mb-0">
              {(userDetails?.EmpId == albumDetail?.EmpId || galleryCreate) && (
                <a className="add-btncss gal-a me-2" onClick={openFileInput}>
                  <input
                    type="file"
                    name=""
                    id="fileInput"
                    accept="image/*,video/mp4"
                    multiple
                    style={{
                      position: "absolute",
                      top: "43%",
                      right: "33%",
                      visibility: "hidden",
                    }}
                    ref={fileInputRef}
                    onChange={handleFileChange}
                  />

                  <i aria-hidden="true" className="fa fa-upload me-2"></i>
                  {uploadImage}
                </a>
              )}
              <Link to="/Gallery" className="back-gallerybtn m-0">
                <i aria-hidden="true" className="fa fa-angle-left me-2"></i>
                Back
              </Link>
            </div>
          </div>
          <Dialog
            visible={imageDetailShow}
            style={{ width: "75vw", height: "90vh" }}
            onHide={() => setimageDetailShow(false)}
          >
            <div className="popup">
              <div className="row">
                <div className="col-lg-8 p-0">
                  <Swiper
                    modules={[Navigation]}
                    navigation
                    spaceBetween={8}
                    slidesPerView={1}
                    initialSlide={mediaActiveIndex}
                    onSlideChange={(swiper) => {
                      currentIndex = swiper.activeIndex;
                      if (currentIndex !== undefined) {
                        const albumImg = albumData[currentIndex];
                        if (albumImg) {
                          setImageDetail(albumImg);
                        }
                      }
                    }}
                  >
                    {albumData.map((albumImg, index) => (
                      <SwiperSlide key={index}>
                        {FeedMediaCarouselTemplate(albumImg)}
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
                <div className="col-lg-4 p-0">
                  <div className="commhight">
                    <div className="user-info">
                      <div className="main-topinfor break-text">
                        {imageDetail ? (
                          <h3>
                            {moment(imageDetail?.ModifiedDate)
                              .format("L")
                              ?.slice(-4)}
                            : {imageDetail?.AlbumName}
                          </h3>
                        ) : (
                          <h3>2024: Our Year in Review</h3>
                        )}
                        <p>
                          <span>
                            <img
                              src={
                                imageDetail?.UploadedByProfileImage ||
                                defaultImage
                              }
                              onError={handleImageError}
                              alt=""
                            />
                            {imageDetail?.UploadedByName}
                            &nbsp; On &nbsp;
                          </span>
                          <span className="time">
                            {moment(albumDetail?.ModifiedDate).format(
                              "MMM DD YYYY",
                            )}{" "}
                            at {moment(albumDetail?.ModifiedDate).format("LT")}
                          </span>
                        </p>
                      </div>
                      <div className="post-image">
                        <div className="post-footer">
                          <div className="emojis-group">
                            <div className="image"></div>
                          </div>
                          <div className="social-count">
                            <div
                              className="like-wrapper"
                              style={{
                                position: "relative",
                                alignItems: "center",
                                justifyContent: "center",
                                display: "flex",
                              }}
                            >
                              <div className="like-button">
                                <div>
                                  <div className="emojis-group emojis-byuser me-2">
                                    <div
                                      className="image"
                                      style={{
                                        height: "16px !important",
                                        width: "29px !important",
                                      }}
                                    >
                                      {imageDetail?.LikedCount == 0 ? (
                                        <a
                                          className="like-butto "
                                          onMouseEnter={() =>
                                            setMouseDrag(true)
                                          }
                                          onMouseLeave={() =>
                                            setMouseDrag(false)
                                          }
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            class="bi bi-hand-thumbs-up"
                                            viewBox="0 0 16 16"
                                          >
                                            <path d="M8.864.046C7.908-.193 7.02.53 6.956 1.466c-.072 1.051-.23 2.016-.428 2.59-.125.36-.479 1.013-1.04 1.639-.557.623-1.282 1.178-2.131 1.41C2.685 7.288 2 7.87 2 8.72v4.001c0 .845.682 1.464 1.448 1.545 1.07.114 1.564.415 2.068.723l.048.03c.272.165.578.348.97.484.397.136.861.217 1.466.217h3.5c.937 0 1.599-.477 1.934-1.064a1.86 1.86 0 0 0 .254-.912c0-.152-.023-.312-.077-.464.201-.263.38-.578.488-.901.11-.33.172-.762.004-1.149.069-.13.12-.269.159-.403.077-.27.113-.568.113-.857 0-.288-.036-.585-.113-.856a2 2 0 0 0-.138-.362 1.9 1.9 0 0 0 .234-1.734c-.206-.592-.682-1.1-1.2-1.272-.847-.282-1.803-.276-2.516-.211a10 10 0 0 0-.443.05 9.4 9.4 0 0 0-.062-4.509A1.38 1.38 0 0 0 9.125.111zM11.5 14.721H8c-.51 0-.863-.069-1.14-.164-.281-.097-.506-.228-.776-.393l-.04-.024c-.555-.339-1.198-.731-2.49-.868-.333-.036-.554-.29-.554-.55V8.72c0-.254.226-.543.62-.65 1.095-.3 1.977-.996 2.614-1.708.635-.71 1.064-1.475 1.238-1.978.243-.7.407-1.768.482-2.85.025-.362.36-.594.667-.518l.262.066c.16.04.258.143.288.255a8.34 8.34 0 0 1-.145 4.725.5.5 0 0 0 .595.644l.003-.001.014-.003.058-.014a9 9 0 0 1 1.036-.157c.663-.06 1.457-.054 2.11.164.175.058.45.3.57.65.107.308.087.67-.266 1.022l-.353.353.353.354c.043.043.105.141.154.315.048.167.075.37.075.581 0 .212-.027.414-.075.582-.05.174-.111.272-.154.315l-.353.353.353.354c.047.047.109.177.005.488a2.2 2.2 0 0 1-.505.805l-.353.353.353.354c.006.005.041.05.041.17a.9.9 0 0 1-.121.416c-.165.288-.503.56-1.066.56z" />
                                          </svg>
                                          <span className="like-overlay"></span>
                                        </a>
                                      ) : (
                                        UserEmojiReaction(imageDetail?.Reaction)
                                      )}
                                    </div>
                                    <span className="like-overlay"></span>
                                    {mouseDrag && (
                                      <div className="upload-like">
                                        <ul
                                          className="emoji-ul"
                                          onMouseEnter={() =>
                                            setMouseDrag(true)
                                          }
                                          onMouseLeave={() =>
                                            setMouseDrag(false)
                                          }
                                        >
                                          <li>
                                            <img
                                              src="/images/main-body/post/emojis/0.gif"
                                              alt=""
                                              onClick={() =>
                                                AlbumImageLike(
                                                  imageDetail,
                                                  "Like",
                                                )
                                              }
                                            />
                                          </li>
                                          <li>
                                            <img
                                              src="/images/main-body/post/emojis/1.gif"
                                              alt=""
                                              onClick={() =>
                                                AlbumImageLike(
                                                  imageDetail,
                                                  "Love",
                                                )
                                              }
                                            />
                                          </li>
                                          <li>
                                            <img
                                              src="/images/main-body/post/emojis/2.gif"
                                              alt=""
                                              onClick={() =>
                                                AlbumImageLike(
                                                  imageDetail,
                                                  "Laugh",
                                                )
                                              }
                                            />
                                          </li>
                                          <li>
                                            <img
                                              src="/images/main-body/post/emojis/3.gif"
                                              alt=""
                                              onClick={() =>
                                                AlbumImageLike(
                                                  imageDetail,
                                                  "Surprised",
                                                )
                                              }
                                            />
                                          </li>
                                          <li>
                                            <img
                                              src="/images/main-body/post/emojis/5.gif"
                                              alt=""
                                              onClick={() =>
                                                AlbumImageLike(
                                                  imageDetail,
                                                  "Sad",
                                                )
                                              }
                                            />
                                          </li>
                                        </ul>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <span className="like-list">
                                {" "}
                                {imageDetail?.LikedCount == 0
                                  ? ""
                                  : imageDetail?.LikedCount + " "}{" "}
                                like
                                {imageDetail?.LikedCount != 0 && (
                                  <div className="hover-liked-by">
                                    <ul>
                                      {imageDetail?.LikedList?.map(
                                        (like, i) => (
                                          <li key={i}>
                                            <div className="image"></div>
                                            <img
                                              src={
                                                like?.ReactionProfileImage ||
                                                defaultImage
                                              }
                                              onError={handleImageError}
                                              data-user-popover="1"
                                              alt=""
                                            />
                                            <span>{like?.ReactionByName}</span>
                                          </li>
                                        ),
                                      )}
                                    </ul>
                                  </div>
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="inner-content d-none"
                        style={{ marginLeft: "auto" }}
                      >
                        <p className="m-0 mb-0 pside">
                          <div className="gallery-likes">
                            <div key={imageDetail?.Id}>
                              {EmojiReaction(imageDetail?.LikedList)}
                              {UserEmojiReaction(imageDetail?.LikedList)}
                            </div>

                            {/* {imageDetail?.Reaction === "" && ( */}
                            <div className="upload-like">
                              <ul className="emoji-ul">
                                <li
                                  onClick={() =>
                                    AlbumImageLike(imageDetail, "Like")
                                  }
                                >
                                  <img
                                    src="/images/main-body/post/emojis/0.gif"
                                    alt=""
                                  />
                                </li>
                                <li
                                  onClick={() =>
                                    AlbumImageLike(imageDetail, "Love")
                                  }
                                >
                                  <img
                                    src="/images/main-body/post/emojis/1.gif"
                                    alt=""
                                  />
                                </li>
                                <li
                                  onClick={() =>
                                    AlbumImageLike(imageDetail, "Laugh")
                                  }
                                >
                                  <img
                                    src="/images/main-body/post/emojis/2.gif"
                                    alt=""
                                  />
                                </li>
                                <li
                                  onClick={() =>
                                    AlbumImageLike(imageDetail, "Surprised")
                                  }
                                >
                                  <img
                                    src="/images/main-body/post/emojis/3.gif"
                                    alt=""
                                  />
                                </li>
                                <li
                                  onClick={() =>
                                    AlbumImageLike(imageDetail, "Sad")
                                  }
                                >
                                  <img
                                    src="/images/main-body/post/emojis/5.gif"
                                    alt=""
                                  />
                                </li>
                              </ul>
                            </div>
                            {/* )}    */}
                          </div>
                        </p>
                        <p className="pside">
                          <a> {imageDetail?.CommentCount} Comments </a>
                        </p>
                      </div>
                      <div
                        className="mt-2 comment-div"
                        style={{
                          borderTop: "none",
                          padding: "0px",
                        }}
                      >
                        <div className="comment-onpost-modal">
                          <Commnent
                            sendCommentData={AlbumImageComment}
                            reciveCommentData={imageComment}
                            employeesList={employee}
                            commentType={EditCommentId}
                          />
                          {loader ? (
                            <div
                              style={{
                                top: "181px",
                                right: " 67px",
                              }}
                              className="login-loader"
                            ></div>
                          ) : (
                            ""
                          )}
                          {/* {imageComment && (
                            <button
                              onClick={() => {
                                AlbumImageComment(imageDetail, true);
                              }}
                              className="add-btncss"
                            >
                              <i
                                className="fa fa-angle-right"
                                aria-hidden="true"
                              />
                            </button>
                          )} */}
                        </div>
                        <strong>Comments</strong>
                        <div
                          className="is-post"
                          style={{
                            borderRadius: "0",
                          }}
                        >
                          <div className="content-wrap">
                            {imageDetail?.CommentList?.map((el) => (
                              <div className="gallery-comments">
                                <div className="user-block">
                                  <div className="image w-auto">
                                    <img
                                      src={
                                        el?.ReactionProfileImage || defaultImage
                                      }
                                      onError={handleImageError}
                                      data-demo-src={el?.ReactionProfileImage}
                                      data-user-popover={6}
                                    />
                                  </div>
                                  <div className="user-info">
                                    <a>{el?.ReactionByName}</a>
                                    <span className="time">
                                      {" "}
                                      <PostDate
                                        LastCommentDate={el?.ModifiedDate}
                                      />
                                    </span>
                                    <p
                                      className="m-0 break-text"
                                      dangerouslySetInnerHTML={renderFeedText(
                                        el?.Reaction,
                                      )}
                                    ></p>
                                  </div>
                                </div>
                                {el?.IsMyReaction == 1 && (
                                  <div className="comment-actions">
                                    <a
                                      onClick={() => {
                                        EditComment(el);
                                      }}
                                    >
                                      <img
                                        src="/images/tickets/edit-ico.svg"
                                        className="editdivinfo"
                                        title="Edit"
                                      />
                                    </a>
                                    <a onClick={() => DeleteComment(el)}>
                                      {" "}
                                      <img
                                        src="/images/tickets/delete.svg"
                                        className="editdivinfo"
                                        title="Delete"
                                      />
                                    </a>
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Dialog>
          {hasMore ? (
            <div className="notfound">
              <img src="/images/gallery/GallerynodataFound.png" alt="" />
              <p className="how-it mb-4">No data found.</p>
            </div>
          ) : (
            <div className="gallery">
              {albumData.map((album, index) => {
                return (
                  <div
                    className="gallery-image has-background-image"
                    key={index}
                  >
                    {(galleryCreate ||
                      albumDetail?.EmpId == userDetails?.EmpId) && (
                      <button
                        onClick={() => handleCreatedAlbumDelete(album)}
                        className="gallerydeletebtn"
                        title="Delete"
                        data-bs-toggle="modal"
                        data-bs-target="#delete-ed"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-trash"
                          viewBox="0 0 16 16"
                        >
                          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                          <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                        </svg>
                      </button>
                    )}
                    <div className="likescommentlist">
                      <ul>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            fill="currentColor"
                            className="bi bi-heart-fill mr-3"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fillRule="evenodd"
                              d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"
                            ></path>
                          </svg>
                          {album?.LikedCount}
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            fill="currentColor"
                            className="bi bi-chat-dots-fill mr-3"
                            viewBox="0 0 16 16"
                          >
                            <path d="M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM5 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"></path>
                          </svg>
                          {album?.CommentCount}
                        </li>
                      </ul>
                    </div>
                    {FeedMediaTemplate(album, index)}
                    <div className="item-overlay"></div>
                    <div className="overlay-layer">
                      <div className="overlay-content">
                        <div className="media-meta d-flex align-items-center innergallery">
                          <LazyImage
                            src={album?.UploadedByProfileImage}
                            alt={album?.UploadedByName}
                            className="image"
                          />
                          <a className="meta-item is-hoverable">
                            {album?.UploadedByName}
                          </a>
                          <span className="separator">|</span>
                          <span className="meta-item d-flex align-items-center">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="11"
                              height="11"
                              fill="currentColor"
                              className="bi bi-calendar me-1"
                              viewBox="0 0 16 16"
                            >
                              <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                            </svg>
                            {moment(album?.ModifiedDate).format("MMM DD YYYY")}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        {showGallaryDataNotFound && (
          <div className="">
            <div className="notfound">
              <img src="/images/no-data-found/gallery_no_data.png" alt="" />
              <p>{noData}</p>
            </div>
          </div>
        )}
      </div>
      <div className="modal fade" id="delete-ed">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure?</strong>
              <p>Do you really want to delete this image?</p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="deletebtn-click"
                data-bs-dismiss="modal"
                onClick={() => deleteAlbumImage()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      {loading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}

export default SingleGallery;
